export default __webpack_public_path__ + "static/media/rare7.d34f5267.gif";